<template>
  <div>
    <b-card>
      <b-row class="mb-2">
        <b-col>
          <b-button variant="primary" @click="openAddModal">+ Add Integrator</b-button>
        </b-col>
      </b-row>

      <!-- Loading skeleton -->
      <div v-if="loading">
        <b-skeleton width="40%" height="2rem" class="mb-2"/>
        <b-skeleton width="70%" class="mb-1"/>
        <b-skeleton-table :rows="5" :columns="4" hide-header/>
      </div>

      <div v-else-if="!items.length" class="text-center py-4 text-muted">
        No integrators found. Add one to get started.
      </div>

      <b-table
        v-else
        :items="items"
        :fields="fields"
        striped
        hover
        responsive
      >
        <template #cell(is_active)="data">
          <b-badge :variant="data.value ? 'success' : 'secondary'">{{ data.value ? 'Active' : 'Inactive' }}</b-badge>
        </template>
        <template #cell(actions)="data">
          <b-button size="sm" variant="outline-info" class="mr-1" :to="`/integrators/${data.item.id}/contracts`">
            Contracts
          </b-button>
          <b-button size="sm" variant="outline-primary" class="mr-1" @click="openEditModal(data.item)">Edit</b-button>
          <b-button size="sm" variant="outline-danger" @click="deleteItem(data.item.id)">Delete</b-button>
        </template>
      </b-table>
    </b-card>

    <!-- Add/Edit Modal -->
    <b-modal
      v-model="showModal"
      :title="editItem ? 'Edit Integrator' : 'Add Integrator'"
      ok-title="Save"
      @ok="saveItem"
      @hidden="resetForm"
    >
      <b-form-group label="Name">
        <b-form-input v-model="form.name" placeholder="Integrator name" />
      </b-form-group>
      <b-form-group label="Contact Person">
        <b-form-input v-model="form.contact_person" placeholder="Contact name" />
      </b-form-group>
      <b-form-group label="Phone">
        <b-form-input v-model="form.phone" placeholder="+91XXXXXXXXXX" />
      </b-form-group>
      <b-form-group label="Email">
        <b-form-input v-model="form.email" type="email" placeholder="email@example.com" />
      </b-form-group>
      <b-form-group label="Active">
        <b-form-checkbox v-model="form.is_active" switch>
          {{ form.is_active ? 'Active' : 'Inactive' }}
        </b-form-checkbox>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import axios from '@/libs/axios'
import {
  BCard, BRow, BCol, BTable, BButton, BBadge, BSpinner, BModal,
  BFormGroup, BFormInput, BFormCheckbox,
} from 'bootstrap-vue'

export default {
  name: 'IntegratorList',
  components: {
    BCard, BRow, BCol, BTable, BButton, BBadge, BSpinner, BModal,
    BFormGroup, BFormInput, BFormCheckbox,
  },
  data() {
    return {
      loading: false,
      items: [],
      showModal: false,
      editItem: null,
      form: { name: '', contact_person: '', phone: '', email: '', is_active: true },
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'contact_person', label: 'Contact' },
        { key: 'phone', label: 'Phone' },
        { key: 'email', label: 'Email' },
        { key: 'is_active', label: 'Active' },
        { key: 'actions', label: 'Actions' },
      ],
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const { data } = await axios.get('web/integrators')
        // IntegratorController returns { data: paginator } → paginator.data = array
        this.items = data.data?.data || data.data || data.items || data || []
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('Failed to load integrators', { variant: 'danger', title: 'Error' })
      } finally {
        this.loading = false
      }
    },
    openAddModal() {
      this.editItem = null
      this.resetForm()
      this.showModal = true
    },
    openEditModal(item) {
      this.editItem = item
      this.form = { ...item }
      this.showModal = true
    },
    resetForm() {
      this.form = { name: '', contact_person: '', phone: '', email: '', is_active: true }
      this.editItem = null
    },
    async saveItem(bvModalEvt) {
      bvModalEvt.preventDefault()
      try {
        if (this.editItem) {
          await axios.put(`web/integrators/${this.editItem.id}`, this.form)
          this.$bvToast.toast('Integrator updated', { variant: 'success', title: 'Success' })
        } else {
          await axios.post('web/integrators', this.form)
          this.$bvToast.toast('Integrator added', { variant: 'success', title: 'Success' })
        }
        this.showModal = false
        this.fetchData()
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('Failed to save', { variant: 'danger', title: 'Error' })
      }
    },
    async deleteItem(id) {
      if (!confirm('Delete this integrator?')) return
      try {
        await axios.delete(`web/integrators/${id}`)
        this.$bvToast.toast('Deleted', { variant: 'success', title: 'Success' })
        this.fetchData()
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('Failed to delete', { variant: 'danger', title: 'Error' })
      }
    },
  },
}
</script>

<style scoped></style>
